/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Vytvořit účet`
};

const da_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Opret konto`
};

const de_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Konto erstellen`
};

const en_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Create an account`
};

const es_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Crear una cuenta`
};

const fr_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Créer un compte`
};

const hu_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Fiók létrehozása`
};

const it_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Crea un account`
};

const nl_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Account aanmaken`
};

const pl_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Utwórz konto`
};

const pt_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Criar uma conta`
};

const sv_account_create_an_account = /** @type {(inputs: {}) => string} */ () => {
	return `Skapa konto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_create_an_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_create_an_account(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_create_an_account", locale)
	if (locale === "cs") return cs_account_create_an_account(inputs)
	if (locale === "da") return da_account_create_an_account(inputs)
	if (locale === "de") return de_account_create_an_account(inputs)
	if (locale === "en") return en_account_create_an_account(inputs)
	if (locale === "es") return es_account_create_an_account(inputs)
	if (locale === "fr") return fr_account_create_an_account(inputs)
	if (locale === "hu") return hu_account_create_an_account(inputs)
	if (locale === "it") return it_account_create_an_account(inputs)
	if (locale === "nl") return nl_account_create_an_account(inputs)
	if (locale === "pl") return pl_account_create_an_account(inputs)
	if (locale === "pt") return pt_account_create_an_account(inputs)
	return sv_account_create_an_account(inputs)
};
export { account_create_an_account as "account.create_an_account" }